import ctl from "@netlify/classnames-template-literals";
import type { PageLayoutVariant } from "./index";

export const page = (variant: PageLayoutVariant) => {
  const base = ctl(`
  flex
  w-full
  h-auto
  flex-col
  items-center
  bg-white
  text-neutral-900
  rounded-t-xl
  relative
  -mt-3
`);

  const variantStyle = {
    default: ctl(`
      p-6
      xl:pt-14
      2xl:px-24
      xl:pb-24
    `),
    "full-width": ctl(``),
  };

  return `${base} ${variantStyle[variant]}`;
};

export const container = (variant: PageLayoutVariant) => {
  const base = ctl(`
  relative
  flex
  w-full
  h-full
  flex-col
`);

  const variantStyle = {
    default: ctl(`
      max-w-5xl
    `),
    "full-width": ctl(``),
  };

  return `${base} ${variantStyle[variant]}`;
};
